import { render, staticRenderFns } from "./user-vm-drop.vue?vue&type=template&id=21a42c05"
import script from "./user-vm-drop.vue?vue&type=script&lang=js"
export * from "./user-vm-drop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports